<template>
    <modal
        v-if="show"
        class="complianceModal"
        :title="'Enable STIR/SHAKEN'"
        :form="form"
        :submitText="submitTextModal"
        :cancelText="'Cancel'"
        :backText="'Previous'"
        :submitClasses="{
            'is-primary': true,
            'is-busy': form.busy,
        }"
        :actionLeft="actionLeft"
        :submitDisabled="submitDisabled"
        :hideBack="!showBackButton"
        :hideCancel="!showCancelButton"
        @back="handlePreviousStep"
        @closed="handleClosed"
        @submit="handleNextStep"
    >
        <configuration-stepper :type="'simple'" :currentStep="currentStep" :steps="steps" />

        <div v-if="currentStep === 1" class="complianceModal__content complianceModal__preview">
            <div class="complianceModal__previewTitle">STIR/SHAKEN</div>

            <div class="complianceModal__previewDescription">
                Increase trust and answer rates in your calls by <br />
                displaying "Caller Verified."
            </div>

            <div class="complianceModal__previewImage">
                <img :src="`${$window.Config.cdn_url}/images/stir-shaken.png`" alt="" />
            </div>
        </div>

        <div v-if="currentStep === 2" class="complianceModal__content complianceModal--stirStep2">
            <div class="complianceModal__title">Terms of Service and Privicy Policy</div>

            <div class="complianceModal__column">
                <form-checkbox
                    v-model="form.terms_accepted"
                    :error="form.errors.get('message')"
                    :position="'top'"
                >
                    I certify that the associated Business Profile is the originator of the phone
                    calls and certify that I will participate in traceback efforts, including those
                    initiated by the
                    <a href="https://sti-ga.atis.org/" target="_blank"
                    >Secure Telephony Identity Policy Administrator (STI-PA)</a
                    >
                    and the
                    <a href="https://tracebacks.org/" target="_blank">US Telecom Traceback Group</a
                    >.
                </form-checkbox>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapState } from 'pinia';
import stores from 'store/modules';
import Form from 'core/Form';

export default {
    data() {
        return {
            form: new Form({
                terms_accepted: false,
            }),
            currentStep: 1,
            steps: 2,
            showBackButton: false,
            showCancelButton: true,
            actionLeft: true,
        };
    },

    computed: {
        show() {
            return this.showShakenStirAdvancedModal;
        },

        submitTextModal() {
            return this.currentStep === this.steps ? 'Confirm' : 'Next';
        },

        submitDisabled() {
            if (this.currentStep === 1) {
                return false;
            }

            if (this.currentStep === 2) {
                return Boolean(!this.form.terms_accepted);
            }

            return false;
        },

        ...mapState(stores.CallingStore, ['showShakenStirAdvancedModal']),
    },

    watch: {
        show(value) {
            if (value) {
                this.init();
            }
        },
    },

    methods: {
        init() {
            this.reset();
            this.calculateButtons();
        },

        reset() {
            this.form.terms_accepted = false;
            this.form.reset();
            this.currentStep = 1;
            this.showBackButton = true;
            this.showCancelButton = false;
            this.actionLeft = true;
        },

        setStep(step) {
            this.currentStep = step;
            this.calculateButtons();
        },

        calculateButtons() {
            if (this.currentStep > 1) {
                this.showBackButton = true;
                this.showCancelButton = false;
            } else {
                this.showBackButton = false;
                this.showCancelButton = true;
            }
        },

        handleNextStep() {
            if (this.currentStep === 1) {
                this.setStep(2);

                return;
            }

            if (this.currentStep === 2) {
                this.submit();
            }
        },

        async handlePreviousStep() {
            if (this.currentStep === 2) {
                this.setStep(1);
            }
        },

        handleClosed() {
            this.$store.dispatch('handleShowShakenStirAdvancedModal', false);
            this.$emit('closed');
        },

        async submit() {
            try {
                await this.$store.dispatch('updateShakenStirProfile', this.form);
            } catch (e) {
                this.$log.error(e, this.$options.__file, 'submit');
            }
        },
    },
};
</script>
